/** The History key for a risk's control events: they are not field edits, so they share one synthetic key. */
export const RISK_CONTROL_EVENT_KEY = 'riskControlEvent';
